import type { CSSProperties } from 'react'
import { editorPaintedFontStack } from '@messenger/lotus'
import type { EditorCharacterStyleLayer } from '@messenger/lotus'

export type CharacterStyleCss = EditorCharacterStyleLayer

type Axis = keyof EditorCharacterStyleLayer

const AXIS_TO_CSS: {
  [K in Axis]-?: (
    value: NonNullable<EditorCharacterStyleLayer[K]>,
  ) => CSSProperties
} = {
  fontFamily: (v) => ({ fontFamily: editorPaintedFontStack(v) }),
  fontSizePt: (v) => ({ fontSize: `${v}pt` }),
  fontWeight: (v) => ({ fontWeight: v }),
  fontStyle: (v) => ({ fontStyle: v }),
  color: (v) => ({ color: v }),
  textDecoration: (v) => ({ textDecoration: v }),
  textDecorationColor: (v) => ({ textDecorationColor: v }),
  letterSpacing: (v) => ({ letterSpacing: `${v}pt` }),
  textCase: (v) => (v === 'none' ? {} : { textTransform: v }),
  textStrokeWidth: (v) => ({ WebkitTextStrokeWidth: `${v}pt` }),
  textStrokeColor: (v) => ({ WebkitTextStrokeColor: v }),
  textFillColor: (v) => ({ WebkitTextFillColor: v }),
}

export const characterStyleToCss = (
  effective: CharacterStyleCss,
): CSSProperties => {
  const css: CSSProperties = {}
  for (const key of Object.keys(effective) as Axis[]) {
    const value = effective[key]
    if (value === undefined || value === null) continue
    const toCss = AXIS_TO_CSS[key] as
      | ((v: unknown) => CSSProperties)
      | undefined
    if (!toCss) continue
    Object.assign(css, toCss(value))
  }
  return css
}

export default characterStyleToCss
